import WalletSimpleLogo from './WalletSimpleLogo';

export default WalletSimpleLogo;
